import React from 'react'
import styled from 'styled-components'
import Calling from '../../../assets/icons/Calling'
import Instagram from '../../../assets/icons/Instagram'
import Mail from '../../../assets/icons/Mail'
import Telegram from '../../../assets/icons/Telegram'
import Location from '../../../assets/icons/Location'

import Logo from "../../../assets/images/footer-logo.png"
import Facebook from '../../../assets/icons/Facebook'

export default function Sidebar({ change, open }) {

    return (
        <SidebarStyled open={open}>
            <div className='sidebar'>
                <div className='logo'>
                    <div className='logo-wrapper'>
                        <img src={Logo} alt="logo" />
                    </div>
                    <div className='icon'>
                        <span onClick={change}>+</span>
                    </div>
                </div>
                <p>We offer a Intrastate Logistics Network with our multiple offices and also high quality distribution facilities which are staffed by dedicated teams of the top of experts.</p>
                <div className='google'>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3029.256331828373!2d-73.9906736!3d40.6021678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24506974256f3%3A0x3c4a028a8d292e16!2zMjI2MyA4NHRoIFN0ICM1dGgsIEJyb29rbHluLCBOWSAxMTIxNCwg0KHQqNCQ!5e0!3m2!1sru!2s!4v1667632364902!5m2!1sru!2s"
                        style={{ border: "0" }}
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade">
                    </iframe>
                </div>
                <h3>Contact Info</h3>
                <ul>
                    <li className='social-item'>
                        <Location side={"side"} />
                        <a href={"https://t.me/sfeld_24"}>@sfeld_24</a>
                    </li>

                    <li className='social-item'>
                        <Calling />
                        <a href={"tel:+1(202) 9380805"}>
                            +1(202) 9380805
                        </a>
                    </li>
                    <li className='social-item'>
                        <Mail />
                        <a href="https://mail.google.com/mail/u/0/#search/safeeldinc%40gmail.com" target="blank">
                            support@sfeldinc.com
                        </a>
                    </li>
                </ul>
                <div className='social-media'>
                    <div> <a href={"https://t.me/sfeld_24"}><Telegram /></a></div>
                    <div><a href="https://www.facebook.com/profile.php?id=100086904313574"> <Facebook /></a></div>
                    <div><a href='https://www.instagram.com/sf_eld'><Instagram /></a></div>
                </div>
            </div>
        </SidebarStyled>
    )
}

const SidebarStyled = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    z-index: 10;
    left: ${({ open }) => open ? "0" : "-100%"};
    transition: all 0.4s ease-in-out;

    &::-webkit-scrollbar{
        display: none;
    }
    .sidebar{
        background: #10101B;
        width: 500px;
        padding: 40px 30px;
        color: white;
        height: 100vh;

        .logo{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .icon{
                width: 60px;
                height: 60px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                cursor: pointer;
                transition: all 0.3s ease-in-out;

                &:hover{
                    background-color: #404049;
                }
                span{
                    font-size: 72px;
                    transform: rotate(45deg);
                    font-weight: 100;
                    display: inline-block;
                
                }
            }
        }
        p{
            font-size: 18px;
            line-height: 30px;
            margin: 20px 0;
        }
        iframe{
            width: 100%;
            height: 200px;
            border-radius: 10px;
        }
        h3{
            font-size: 32px;
            margin: 30px 0;
        }
        .social-item{
            display: flex;
            gap:18px;
            list-style: none;
            margin-bottom: 20px;
            svg{
                width: 30px;
                height: 30px;
               path stroke{
                    fill: white;
                }
            }
            a{
                font-size: 20px;
                line-height: 24px;
                color: #FFFFFF;
                text-decoration: none
            }
        }

        .social-media{
            display: flex;
            gap:30px;
            div{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #404049;
                transition: all 0.3s ease-in-out;
                &:hover{
                    background: #2B87D0;
;
                }
            }
        }

        @media (max-width: 576px) {
            padding: 50px 20px;
            width: 300px;
            iframe{
                display: none;
            }
            .logo{
                .logo-wrapper{
                    width: 100px;
                    img{
                        width: 100%;
                    }
                }
                .icon{
                    width: 30px;
                    height: 30px;
                    span{
                        font-size: 30px;
                    }
                }
            }
            p{
                font-size: 14px;
                line-height: 19px;
            }

            h3{
                font-size: 20px;
                line-height: 27px; 
            }

            .social-item{
                svg{
                    width: 20px;
                    height:20px;
                }
                a{
                    font-size: 14px;
                    line-height: 19px;
                }
            }

            .social-media{
                div{
                    width: 36px;
                    height: 36px;
                    svg{
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }
    }
`
